// extracted by mini-css-extract-plugin
export default {"content":"vp_JgMpR","inner":"vp_x9jqR","noShrink":"vp_pVzkR","fill":"vp_C9UFf","paddingNone":"vp_SBtG3","paddingMedium":"vp_HNh0P","borderTop":"vp_OIpLj","borderBottom":"vp_o1ZDn"};